import React from "react";
import { SpinnerDiamond  } from 'spinners-react';
import Lottie from 'react-lottie';
import animationData from '../../assets/images/loading.json';

const LoadingSpinner = () => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };

    return (
        <div className="spinner-loader">            
            <Lottie options={defaultOptions} height={150} width={150}
            style={{ position: 'absolute', top: '50%', left: 'calc(50% - 70px)', transform: 'translate(0, -50%)' }}  />
        </div>
    )
}

export default LoadingSpinner
